"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _UISelect = _interopRequireDefault(require("UIComponents/input/UISelect"));

var _getLanguageOptions = require("../internal/utils/getLanguageOptions");

var LanguageSelect = function LanguageSelect(props) {
  var validLanguages = props.validLanguages,
      optionsFilter = props.optionsFilter,
      passThroughProps = (0, _objectWithoutProperties2.default)(props, ["validLanguages", "optionsFilter"]);
  return _react.default.createElement(_UISelect.default, (0, _extends2.default)({}, passThroughProps, {
    options: validLanguages ? (0, _getLanguageOptions.getOptionsForValidLanguages)({
      validLanguages: validLanguages,
      optionsFilter: optionsFilter
    }) : (0, _getLanguageOptions.getLanguageOptions)({
      optionsFilter: optionsFilter
    })
  }));
};

LanguageSelect.propTypes = {
  optionsFilter: _propTypes.default.func,
  validLanguages: _propTypes.default.array
};
var _default = LanguageSelect;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-i18n/static-1.3469/js/components/LanguageSelect.js
// module id = 732
// module chunks = 209 210 211 212